import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

import {
  Grid,
  MenuItem,
  Checkbox,
  Box,
  Typography,
  Card,
  Autocomplete,
  TextField,
  Modal,
} from "@mui/material";
import { keyframes } from "@mui/system";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";

const CustomStepper = ({ title }) => (
  <Box mb={3} display="flex" justifyContent="center">
    <Typography
      variant="h6"
      sx={{ fontWeight: "bold", color: "#2e7fae", textAlign: "center" }}
    >
      {title}
    </Typography>
  </Box>
);

const DoctorModal = ({ open, handleClose, notificationId, patientId }) => {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
    const userid = loginData?.userid;
    const navigate = useNavigate();
  
    const [loading, setLoading] = useState(false);
    const [renderingDoctorNames, setRenderingDoctorNames] = useState([]);
    const [dutyDoctorNames, setDutyDoctorNames] = useState([]);
  
    const [renderingDoctorInput, setRenderingDoctorInput] = useState("");
    const [dutyDoctorInput, setDutyDoctorInput] = useState("");
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  
    const [doctorMap, setDoctorMap] = useState({
      ccid: userid,
      date: new Date().toISOString().slice(0, 10),
      renderingdoctorId: "",
      dutydoctorIds: [], // array for multiple selection
    });
  
    const renderingSearchRef = useRef(null);
    const dutySearchRef = useRef(null);
  
    // 🔹 Fetch doctor names for a given type
    const fetchDoctorNames = async (doctorType, setter, searchTerm = "") => {
      try {
        const secretKey = await fetchSecretKey();
        const token = loginData?.token;
        let response;
  
        if (searchTerm.trim()) {
          response = await axios.post(
            `/api/doctorregistration/searchByCcid/${userid}`,
          { searchTerm, doctorType },
            { headers: { Authorization: `Bearer ${token}` } }
          );
        } else {
          response = await axios.get(
            `/api/doctorregistration/doctorType/${doctorType}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
        }
  
        if (response.status === 200) {
          const decrypted = decryptBody(response.data, secretKey);
          setter(Array.isArray(decrypted) ? decrypted : []);
        }
      } catch (err) {
        console.error("Error fetching doctors:", err);
      }
    };
  
    // 🔹 Debounced search for Rendering Doctor
    useEffect(() => {
      if (renderingSearchRef.current) clearTimeout(renderingSearchRef.current);
      renderingSearchRef.current = setTimeout(() => {
        if (renderingDoctorInput !== "") {
          fetchDoctorNames("RENDERING_DOCTOR", setRenderingDoctorNames, renderingDoctorInput);
        } else {
          fetchDoctorNames("RENDERING_DOCTOR", setRenderingDoctorNames);
        }
      }, 500);
      return () => clearTimeout(renderingSearchRef.current);
    }, [renderingDoctorInput]);
  
    // 🔹 Debounced search for Duty Doctor
    useEffect(() => {
      if (dutySearchRef.current) clearTimeout(dutySearchRef.current);
      dutySearchRef.current = setTimeout(() => {
        if (dutyDoctorInput !== "") {
          fetchDoctorNames("DUTY_DOCTOR", setDutyDoctorNames, dutyDoctorInput);
        } else {
          fetchDoctorNames("DUTY_DOCTOR", setDutyDoctorNames);
        }
      }, 500);
      return () => clearTimeout(dutySearchRef.current);
    }, [dutyDoctorInput]);
  
    // 🔹 Initial load
    useEffect(() => {
      fetchDoctorNames("RENDERING_DOCTOR", setRenderingDoctorNames);
      fetchDoctorNames("DUTY_DOCTOR", setDutyDoctorNames);
    }, []);
  
    // --- Check Online / Last Seen ---
 const getOnlineStatus = (lastActivity) => {
    if (!lastActivity) return "Last seen: unknown";

    const last = new Date(lastActivity);
    const now = new Date();

    const diffMs = now - last;
    const diffMin = Math.floor(diffMs / 60000); // convert ms → minutes

    // 🟢 Online within 2 minutes
    if (diffMin < 2) return "🟢 Online";

    // Minutes ago
    if (diffMin < 60) return `Last seen: ${diffMin} min ago`;

    // Hours ago
    const hours = Math.floor(diffMin / 60);
    if (hours < 24) return `Last seen: ${hours} hr ago`;

    // Yesterday
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    if (
      last.getDate() === yesterday.getDate() &&
      last.getMonth() === yesterday.getMonth() &&
      last.getFullYear() === yesterday.getFullYear()
    ) {
      return "Last seen: yesterday";
    }

    // Default → show date
    return `Last seen: ${last.toLocaleDateString()}`;
  };

    // 🔹 Submit Mapping
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!doctorMap.renderingdoctorId || doctorMap.dutydoctorIds.length === 0) {
        toast.error("Please select Rendering and at least one Duty Doctor.");
        return;
      }
  
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = loginData?.token;
  
        const rawPayload = {
          
         
         
            notificationId,
            patientId,
            renderingdoctorId: doctorMap.renderingdoctorId,
            dutydoctorIds: doctorMap.dutydoctorIds, 
         
        };
  
        const encryptedData = encryptBody(rawPayload, secretKey);
  
        const response = await axios.post(`/api/notifications/pushToDoctor`, encryptedData, {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (response.status === 200) {
      const decrypted = decryptBody(response.data, secretKey);
  
      if (decrypted?.success === false) {
        toast.error(decrypted?.message || "Failed to Push Notification.");
      } else {
        toast.success(decrypted?.message || "Notification Pushed to Doctor successfully!");
        handleClose();
      }
    }
  } catch (err) {
    console.error("Error submitting Notification:", err);
    toast.error("Failed to Push Notification");
  } finally {
    setLoading(false);
  }
    };
  
    const spinAnimation = keyframes`
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    `;
    const dotPositions = [
      { top: "5%", left: "50%" },
      { top: "20%", left: "80%" },
      { top: "50%", left: "95%" },
      { top: "80%", left: "80%" },
      { top: "95%", left: "50%" },
      { top: "80%", left: "20%" },
      { top: "50%", left: "5%" },
      { top: "20%", left: "20%" },
    ];
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "75%",          // increased width
      maxWidth: "900px",    // wider modal
      height: "90vh",        // increased height
      bgcolor: "background.paper",
      borderRadius: 3,
      boxShadow: 24,
      p: 2,
      overflow: "hidden",    // 🚀 remove scrolling
    }}
  >
        {loading && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 1300,
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 80,
                height: 80,
                animation: `${spinAnimation} 1.5s linear infinite`,
              }}
            >
              {dotPositions.map((pos, index) => (
                <Box
                  key={index}
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: "#1A237E",
                    position: "absolute",
                    ...pos,
                  }}
                />
              ))}
            </Box>
          </Box>
        )}

       <Card
  sx={{
    padding: 4,
    width: "100%",
    height: "100%",
    borderRadius: 4,
  }}
>
          <MDBox pt={1} pb={1} px={1}>
            <CustomStepper title="Push Notification To-Doctor" />

            <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              {/* 🔹 Rendering Doctor Section */}
              <Grid item xs={12}>
                <Typography variant="h6" sx={{ color: "#1A237E", mb: 1 }}>
                  Rendering Doctor
                </Typography>
              </Grid>

              {/* <Grid item xs={6}>
                <TextField label="Doctor Type" fullWidth value="RENDERING_DOCTOR" disabled />
              </Grid> */}

               

                <Grid item xs={12}>
                  <Autocomplete
                    options={renderingDoctorNames}
                     clearIcon={null}         
  closeIcon={null}         

                    getOptionLabel={(option) =>
                      option ? `${option.firstname} ${option.lastname}` : ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    value={
                      renderingDoctorNames.find(
                        (doc) => doc.id === doctorMap.renderingdoctorId
                      ) || null
                    }
                   onChange={(e, newValue) => {
    setDoctorMap({
      ...doctorMap,
      renderingdoctorId: newValue?.id || "",
    });
         setRenderingDoctorInput(
      newValue ? `${newValue.firstname} ${newValue.lastname}` : ""
    );
  }}

                    inputValue={renderingDoctorInput}
                    onInputChange={(e, newValue, reason) => {
                     if (reason === "input") {
      setRenderingDoctorInput(newValue); // typing
    }
   
  }}
                    renderOption={(props, option) => {
                      const status = getOnlineStatus(option.lastActivity);
                      const isOnline = status.includes("Online");

                      return (
                        <li
                          {...props}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            padding: "6px 12px",
                          }}
                        >
                          <strong>
                            {option.firstname} {option.lastname}
                          </strong>

                          <small
                            style={{
                              color: isOnline ? "green" : "#888",
                              marginTop: 2,
                            }}
                          >
                            {status}
                          </small>
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Rendering Doctor"
                        placeholder="Search Rendering Doctor"

                        variant="outlined"
                         InputProps={{
      ...params.InputProps,
      endAdornment: (
        <>
          {doctorMap.renderingdoctorId && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={() => {
                  setDoctorMap({ ...doctorMap, renderingdoctorId: "" });
                  setRenderingDoctorInput("");
                }}
              >
                ✕
              </IconButton>
            </InputAdornment>
          )}
          {params.InputProps.endAdornment}
        </>
      ),
    }}
                      />
                    )}
                  />
                  
                </Grid>

              {/* 🔹 Duty Doctor Section */}
              <Grid item xs={12} mt={2}>
                <Typography variant="h6" sx={{ color: "#2e7fae", mb: 1 }}>
                  Duty Doctor
                </Typography>
              </Grid>

              {/* <Grid item xs={6}>
                <TextField label="Doctor Type" fullWidth value="DUTY_DOCTOR" disabled />
              </Grid> */}

               <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={dutyDoctorNames}
                    getOptionLabel={(option) =>
                      `${option.firstname} ${option.lastname}`
                    }
                    value={selectedDoctors}
                    onChange={(e, newValue) => {
                      setSelectedDoctors(newValue);
                      setDoctorMap({
                        ...doctorMap,
                        dutydoctorIds: newValue.map((doc) => doc.id),
                      });
                    }}
                    inputValue={dutyDoctorInput}
                    onInputChange={(e, val, reason) => {
                      if (reason === "input") setDutyDoctorInput(val);
                    }}
                    renderOption={(props, option, { selected }) => {
                      const status = getOnlineStatus(option.lastActivity);
                      const isOnline = status.includes("Online");

                      return (
                        <li
                          {...props}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            padding: "6px 12px",
                          }}
                        >
                          <Box display="flex" alignItems="center">
                            <Checkbox checked={selected} />
                            <strong>
                              {option.firstname} {option.lastname}
                            </strong>
                          </Box>

                          <small
                            style={{
                              color: isOnline ? "green" : "#888",
                              marginLeft: 40,
                            }}
                          >
                            {status}
                          </small>
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Duty Doctors"
                        placeholder="Search Duty Doctors"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
            </Grid>

            {/* 🔹 Buttons */}
            <MDBox mt={3} display="flex" justifyContent="space-between">
              <MDButton
                variant="outlined"
                onClick={() => handleClose()}
                style={{
                  backgroundColor: "#1A237E",
                  color: "#fff",
                  textTransform: "none",
                }}
              >
                Cancel
              </MDButton>

              <MDButton
                type="submit"
                variant="contained"
                style={{
                  backgroundColor: "#1A237E",
                  color: "#fff",
                  textTransform: "none",
                }}
              >
                Submit
              </MDButton>
            </MDBox>
          </form>
          </MDBox>
        </Card>
      </Box>
    </Modal>
  );
};

export default DoctorModal;
